import { render, staticRenderFns } from "./rx-disclaimer-tooltip.vue?vue&type=template&id=61756df4&scoped=true"
import script from "./rx-disclaimer-tooltip.vue?vue&type=script&lang=js"
export * from "./rx-disclaimer-tooltip.vue?vue&type=script&lang=js"
import style0 from "./rx-disclaimer-tooltip.vue?vue&type=style&index=0&id=61756df4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61756df4",
  null
  
)

export default component.exports